import { useState, useEffect } from 'react'
import axios from 'axios'

function useAxiosFetch(url) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    setLoading(true)
    setData(null)
    setError(null)
    const source = axios.CancelToken.source()
    axios.get(url, { cancelToken: source.token })
      .then(res => {
        setLoading(false)
        res.content && setData(res.content)
        res.data.content && setData(res.data.content)
        res.data && !res.data.content && setData(res.data)
      })
      .catch(err => {
        setLoading(false)
        setError(err?.message || err || 'Error')
      })
    return () => {
      source.cancel()
    }
  }, [url])

  return { data, loading, error }
}

export default useAxiosFetch
